import { render, staticRenderFns } from "./QrFile.vue?vue&type=template&id=7f159afb&scoped=true&lang=pug"
import script from "./QrFile.vue?vue&type=script&lang=js"
export * from "./QrFile.vue?vue&type=script&lang=js"
import style0 from "./QrFile.vue?vue&type=style&index=0&id=7f159afb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f159afb",
  null
  
)

export default component.exports